module.exports = __webpack_public_path__ + "static/media/iwan-simonis.30b9b3d7.png";